import React, { FC } from 'react';

import cn from 'classnames';

import css from './styles.css';

interface VolumeMeterProps {
    volume: number;
    min?: number;
    max?: number;
    length: number;
}
interface ScaleTickProps {
    active: boolean;
}
const ScaleTick: FC<ScaleTickProps> = ({ active }) => {
    return <div className={cn(css.scaleTick, { [css.active]: active })}></div>;
};
export const VolumeMeter: FC<VolumeMeterProps> = ({ volume, min = 0, max = 1, length }) => {
    const volumePercent = (volume - min) / (max - min);
    return (
        <div className={css.wrapper}>
            {Array.from({ length }, (_v, k) => (
                <ScaleTick key={k} active={k / length < volumePercent} />
            ))}
        </div>
    );
};
